import server from "../../../../server";

const defaultPageNumber = 0;
const defaultPageSize = 10;


export async function getAssetList(searchQuery: string, pageSize = defaultPageSize, pageNumber = defaultPageNumber, categoryId?: string) {

    const payload: any = {};

    if (categoryId) {
        payload.categoryId = categoryId;
        payload.status = "IN_STOCK";
    }

    const response = await server.asset.search(pageNumber, pageSize, payload);
    return response;

}